module.exports = __webpack_public_path__ + "img/vlada-zzh.c6e2f51c.png";